interface MessageBubbleProps {
  speaker: string;
  message: string;
}

export function MessageBubble({ speaker, message }: MessageBubbleProps) {
  return (
    <div className="space-y-2">
      <p className="font-medium text-[#1a1817]">{speaker}:</p>
      <p className="text-[#6b6866] leading-relaxed">{message}</p>
    </div>
  );
}
